<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" :model="vrInfo" :rules="rules" >
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名：" prop="baseName" label-width="100px">
                <el-input :disabled="!!id" v-model.trim="vrInfo.baseName" placeholder="请填写您的真实姓名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所在企业：" prop="baseCompanyName" label-width="100px">
                <el-select disabled filterable v-model="vrInfo.baseCompanyName" clearable placeholder="请选择企业">
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码：" prop="basePhone" label-width="100px">
                <el-input v-model.trim="vrInfo.basePhone" placeholder="请填写您手机号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="户籍地址：" prop="erAddDistrict" label-width="100px">
                <el-cascader
                  :props="{label:'n',value:'n',children:'c'}"
                  v-model="vrInfo.erAddDistrict"
                  :options="district"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号：" prop="baseIdcrad" label-width="100px">
                <el-input v-model.trim="vrInfo.baseIdcrad" placeholder="请填写您的身份证号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label-width="140px" label="是否已返园复工：" prop="erIsRework">
                <el-radio v-model="vrInfo.erIsRework" :label="1">已复工</el-radio>
                <el-radio v-model="vrInfo.erIsRework" :label="2">未复工</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预计复工时间：" :prop="erReworkTimeVerify" v-if="vrInfo.erIsRework==2">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.erReworkTime"
                  type="date"
                  :disabled="vrInfo.erHaveReworkTime==2"
                  :picker-options="expireTimeOption"
                  :key="vrInfo.erIsRework"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="复工时间：" :prop="erReworkTimeVerify" v-if="vrInfo.erIsRework==1">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.erReworkTime"
                  type="date"
                  :key="vrInfo.erIsRework"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="vrInfo.erIsRework==2">
               <label
                    class="el-checkbox"
                    style="margin-top:7px; margin-left:20px;"
                    :class="vrInfo.erHaveReworkTime==2?'is-checked':''"
                    @click="haveReworkTimeChange"
                  >
                  <span
                    class="el-checkbox__input"
                    :class="vrInfo.erHaveReworkTime==2?'is-checked':''"
                  >
                    <span class="el-checkbox__inner"></span>
                  </span>
                  <span class="el-checkbox__label">未知，需等待园区或企业通知</span>
                </label>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="180px" label="是否已返回工作所在地：" prop="erIsReturn">
                <el-radio v-model="vrInfo.erIsReturn" :label="1">已返回</el-radio>
                <el-radio v-model="vrInfo.erIsReturn" :label="2">未返回</el-radio>
                <el-radio v-model="vrInfo.erIsReturn" :label="3">未离开</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="vrInfo.erIsReturn!=3">
            <el-col :span="14">
              <el-form-item label="返程时间：" prop="erReturnTime" label-width="100px">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.erReturnTime"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="返乡时间：">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.erLeaveTime"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="假期所在地区：" prop="erAddHolidayDistrict" label-width="120px">
                <el-cascader
                  :props="{label:'n',value:'n',children:'c'}"
                  v-model="vrInfo.erAddHolidayDistrict"
                  :options="district"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="假期所在地区详细地址：" prop="erHolidayAddress">
                <el-input
                  v-model.trim="vrInfo.erHolidayAddress"
                  maxlength="30"
                  placeholder="请详细填写您假期居住地地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="工作地居住地址：" prop="erLocation">
                <el-input
                  v-model.trim="vrInfo.erLocation"
                  maxlength="30"
                  placeholder="请详细填写您返工后居住地地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <div class="info-item">
            <el-col :span="24">
              <el-form-item label-width="140px" label="假期使用通勤工具：" prop="vrTraffic">
                <el-checkbox-group>
                  <label
                    class="el-checkbox"
                    :class="vrInfo.erIsAirplane==1?'is-checked':''"
                    @click="changeTraffic('erIsAirplane')"
                  >
                    <span
                      class="el-checkbox__input"
                      :class="vrInfo.erIsAirplane==1?'is-checked':''"
                    >
                      <span class="el-checkbox__inner"></span>
                    </span>
                    <span class="el-checkbox__label">飞机</span>
                  </label>
                  <label
                    class="el-checkbox"
                    :class="vrInfo.erIsBulletTrain==1?'is-checked':''"
                    @click="changeTraffic('erIsBulletTrain')"
                  >
                    <span
                      class="el-checkbox__input"
                      :class="vrInfo.erIsBulletTrain==1?'is-checked':''"
                    >
                      <span class="el-checkbox__inner"></span>
                    </span>
                    <span class="el-checkbox__label">动车</span>
                  </label>
                  <label
                    class="el-checkbox"
                    :class="vrInfo.erIsBus==1?'is-checked':''"
                    @click="changeTraffic('erIsBus')"
                  >
                    <span class="el-checkbox__input" :class="vrInfo.erIsBus==1?'is-checked':''">
                      <span class="el-checkbox__inner"></span>
                    </span>
                    <span class="el-checkbox__label">客车</span>
                  </label>
                  <label
                    class="el-checkbox"
                    :class="vrInfo.erIsPrivateCar==1?'is-checked':''"
                    @click="changeTraffic('erIsPrivateCar')"
                  >
                    <span
                      class="el-checkbox__input"
                      :class="vrInfo.erIsPrivateCar==1?'is-checked':''"
                    >
                      <span class="el-checkbox__inner"></span>
                    </span>
                    <span class="el-checkbox__label">私家车</span>
                  </label>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="飞机航班号：" prop="erFlightNumber" v-if="vrInfo.erIsAirplane==1" label-width="110px">
                <el-input
                  v-model.trim="vrInfo.erFlightNumber"
                  maxlength="20"
                  placeholder="例如CZ34987号航班"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="动车班次：" prop="erTrainService" v-if="vrInfo.erIsBulletTrain==1" label-width="110px">
                <el-input
                  v-model.trim="vrInfo.erTrainService"
                  maxlength="20"
                  placeholder="例如G3107列车 1月20号班次"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="客车班次：" prop="erBusNumber" v-if="vrInfo.erIsBus==1" label-width="110px">
                <el-input
                  v-model.trim="vrInfo.erBusNumber"
                  maxlength="20"
                  placeholder="请描述客车路线以及乘车时间"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>

          <div class="info-item">
            <el-col :span="24">
              <el-form-item label-width="260px" label="本人是否有发热、乏力、干咳等症状：" prop="erHealth">
                <el-radio v-model="vrInfo.erHealth" :label="1">无</el-radio>
                <el-radio v-model="vrInfo.erHealth" :label="2">有</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="vrInfo.erHealth==2">
              <el-form-item label="症状描述：" prop="erHealthRemark" label-width="100px">
                <el-input
                  type="textarea"
                  v-model.trim="vrInfo.erHealthRemark"
                  maxlength="50"
                  placeholder="请详细描述症状，如具体体温等信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
          <div class="info-item">
            <el-col :span="24">
              <el-form-item label-width="350px" label="家人 / 同住 / 邻居是否有发热、乏力、干咳等症状？：" prop="erFamilyHealth">
                <el-radio v-model="vrInfo.erFamilyHealth" :label="1">无</el-radio>
                <el-radio v-model="vrInfo.erFamilyHealth" :label="2">有</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="vrInfo.erFamilyHealth==2">
              <el-form-item label="症状描述：" prop="erFamilyHealthRemark" label-width="100px">
                <el-input
                  type="textarea"
                  v-model.trim="vrInfo.erFamilyHealthRemark"
                  maxlength="50"
                  placeholder="请详细描述具体人员，病症情况，病患接触情况等"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
          <div class="info-item">
            <el-col :span="24">
              <el-form-item
                label="近一个月内是否前往过湖北省、浙江温州市等地区（含转车、转机停留）："
                prop="erContact"
              >
                <el-radio v-model="vrInfo.erContact" :label="1">无</el-radio>
                <el-radio v-model="vrInfo.erContact" :label="2">有</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="vrInfo.erContact==2">
              <el-form-item label="详情描述：" prop="erContactRemark" label-width="100px">
                <el-input
                  type="textarea"
                  v-model.trim="vrInfo.erContactRemark"
                  maxlength="50"
                  placeholder="请详细描述症状，如具体体温等信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
          <div class="info-item">
            <el-col :span="24">
              <el-form-item
                label-width="320px"
                label="是否有新型冠状感染者（包括疑似病例）接触史："
                prop="erContactHistory"
              >
                <el-radio v-model="vrInfo.erContactHistory" :label="1">无</el-radio>
                <el-radio v-model="vrInfo.erContactHistory" :label="2">有</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="vrInfo.erContactHistory==2">
              <el-form-item label="详情描述：" prop="erContactHistoryRemark" label-width="100px">
                <el-input
                  type="textarea"
                  v-model.trim="vrInfo.erContactHistoryRemark"
                  maxlength="50"
                  placeholder="请详细描述接触地区以及停留时间等信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </div>
          <div class="info-item">
            <el-col :span="24">
              <el-form-item
                label-width="340px"
                label="是否已按工作属地政策需求，完成居家隔离7/14天："
                prop="erIsIsolation"
              >
                <el-radio v-model="vrInfo.erIsIsolation" :label="2">无</el-radio>
                <el-radio v-model="vrInfo.erIsIsolation" :label="1">有</el-radio>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="18" v-if="vrInfo.erIsIsolation==1">
              <el-form-item label="隔离开始时间：" prop="erIsolationStartTime">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.erIsolationStartTime"
                  :picker-options="startDatePicker"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="隔离结束时间：" prop="erIsolationEndTime">
                <el-date-picker
                  value-format="yyyy-MM-dd hh:mm:ss"
                  v-model="vrInfo.erIsolationEndTime"
                  :picker-options="endDatePicker"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
          </div>
        </el-col>
      </el-row>
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <el-form-item label="其它备注信息：" prop="erOtherRemark">
            <el-input type="textarea" v-model.trim="vrInfo.erOtherRemark" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="text-right" style="margin-top: 20px;">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="success" @click="submit" size="small" :loading="submitLoading">确认</el-button>
    </div>
  </div>
</template>

<script>
import * as global from "../../config/mUtils";
import * as getData from "../../service/getData";
import District from "../../plugins/jd_province_city_area_id";
export default {
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7;
        }
      },
      // startDatePicker: this.beginDate(),
      // endDatePicker: this.processDate(),
      vrInfo: {
        erAddDistrict: "",
        erAddHolidayDistrict: "",

        baseName: "",
        baseCompanyId: "",
        baseCompanyName: "",
        baseIdcrad: "",
        basePhone: "",
        baseProvince: "",
        baseCity: "",
        baseDistrict: "",
        // erReworkTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        erHolidayProvince: "",
        erHolidayCity: "",
        erHolidayDistrict: "",
        erHolidayAddress: "",
        erLocation: "",
        erIsReturn: 2,
        erReturnTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        erHealth: 1,
        erHealthRemark: "",
        erContact: 1,
        erContactRemark: "",
        erContactHistory: 1,
        erContactHistoryRemark: "",
        erIsAirplane: 2,
        erIsBulletTrain: 2,
        erIsBus: 2,
        erIsPrivateCar: 2,
        erFlightNumber: "",
        erTrainService: "",
        erBusNumber: "",
        erOtherRemark: "",
        // erIsRework: 2,
        // erLeaveTime: "",
        erFamilyHealth: 1,
        erFamilyHealthRemark: "",
        erIsIsolation: 2,
        // erIsolationStartTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        // erIsolationEndTime: "",
        erHaveReworkTime:1,
      },
      rules: {
        baseName: [
          { required: true, message: "请输入姓名", trigger: ["blur", "change"] }
        ],
        baseCompanyId: [
          { required: true, message: "请选择企业", trigger: ["blur", "change"] }
        ],
        basePhone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { pattern: global.phoneRule5, message: "手机号码格式错误" }
        ],
        erAddDistrict: [
          {
            required: true,
            message: "请选择本人户籍",
            trigger: ["blur", "change"]
          }
        ],
        // erReworkTime: [
        //   {
        //     required: true,
        //     message: "请选择复工时间",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // erReworkTimeNone: [
        //   {
        //     required: false,
        //     trigger: ["blur", "change"]
        //   }
        // ],
        baseIdcrad: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { pattern: global.idcard, message: "身份证号码格式错误" }
        ],
        erReturnTime: [
          {
            required: true,
            message: "请选择返程时间",
            trigger: ["blur", "change"]
          }
        ],
        erAddHolidayDistrict: [
          {
            required: true,
            message: "请选择假期所在地区",
            trigger: ["blur", "change"]
          }
        ],
        erHolidayAddress: [
          {
            required: true,
            message: "请输入假期所在居住地址",
            trigger: ["blur", "change"]
          }
        ],
        erLocation: [
          {
            required: true,
            message: "请输入工作地居住地址",
            trigger: ["blur", "change"]
          }
        ],
        erFlightNumber: [
          {
            required: true,
            message: "请输入航班号",
            trigger: ["blur", "change"]
          }
        ],
        erTrainService: [
          {
            required: true,
            message: "请输入动车班次",
            trigger: ["blur", "change"]
          }
        ],
        erBusNumber: [
          {
            required: true,
            message: "请输入客车班次",
            trigger: ["blur", "change"]
          }
        ],
        erHealthRemark: [
          {
            required: true,
            message: "请输入症状描述",
            trigger: ["blur", "change"]
          }
        ],
        erFamilyHealthRemark: [
          {
            required: true,
            message: "请输入家人健康症状描述",
            trigger: ["blur", "change"]
          }
        ],
        erContactRemark: [
          {
            required: true,
            message: "请输入前往过疫区情况描述",
            trigger: ["blur", "change"]
          }
        ],
        // erIsolationStartTime: [
        //   {
        //     required: true,
        //     message: "请选择隔离开始时间",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // erIsolationEndTime: [
        //   {
        //     required: true,
        //     message: "请选择隔离结束时间",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        erContactHistoryRemark: [
          {
            required: true,
            message: "请输入接触人员等信息",
            trigger: ["blur", "change"]
          }
        ]
      },
      submitLoading: false,
      companyList: [],
      district: District
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  props: ["id"],
  computed: {
    // erReworkTimeVerify(){
    //   if(this.vrInfo.erIsRework==2&&this.vrInfo.erHaveReworkTime==2){
    //     return 'erReworkTimeNone'
    //   }else{
    //     return 'erReworkTime'
    //   }
    // }
  },
  methods: {
    // beginDate(){
    //   const self = this
    //   return {
    //     disabledDate(time){
    //       if (self.vrInfo.erIsolationEndTime) {
    //         return new Date(self.vrInfo.erIsolationEndTime).getTime() < time.getTime()
    //       } else {
    //         // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
    //       }
    //     }
    //   }
    // },
    // processDate() {
    //   const  self = this
    //   return {
    //     disabledDate(time) {
    //       if (self.vrInfo.erIsolationStartTime) { 
    //         return new Date(self.vrInfo.erIsolationStartTime).getTime() > time.getTime()
    //       } else {
    //         // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
    //       }
    //     }
    //   }
    // },
    timeFormat(time) {
      return global.toDateTime(time);
    },
    close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    // haveReworkTimeChange(){
    //   if(this.vrInfo.erHaveReworkTime==2){
    //     this.vrInfo.erHaveReworkTime=1;
    //   }else{
    //     this.vrInfo.erHaveReworkTime=2;
    //   }
    //   this.$nextTick(()=>{
    //     this.$refs.info.validateField('erReworkTimeNone')
    //   })
    // },
    init() {
      getData.indexDate().then(res => {
        if (res.data.code == "success") {
          let datas = res.data.data;
          this.vrInfo.baseCompanyId = datas.companyId;
          this.vrInfo.baseCompanyName = datas.companyName;
        }
      });
      if (this.id) {
        getData
          .vrDetail(this.id)
          .then(res => {
            if (res.data.code != "success") {
              this.$message.error(res.data.message);
              return;
            }
            this.vrInfo = res.data.data.epidemicRegister;
            this.vrInfo.erAddDistrict = [
              this.vrInfo.baseProvince,
              this.vrInfo.baseCity,
              this.vrInfo.baseDistrict
            ];
            console.log(this.vrInfo.erAddDistrict)
            this.vrInfo.erAddHolidayDistrict = [
              this.vrInfo.erHolidayProvince,
              this.vrInfo.erHolidayCity,
              this.vrInfo.erHolidayDistrict
            ];
          })
          .catch(_ => {
            console.log(_);
          });
      }
    },
    submit() {
      this.$refs["info"].validate(valid => {
        if (valid) {
          this.vrInfo.baseProvince = this.vrInfo.erAddDistrict[0];
          this.vrInfo.baseCity = this.vrInfo.erAddDistrict[1];
          this.vrInfo.baseDistrict = this.vrInfo.erAddDistrict[2];

          this.vrInfo.erHolidayProvince = this.vrInfo.erAddHolidayDistrict[0];
          this.vrInfo.erHolidayCity = this.vrInfo.erAddHolidayDistrict[1];
          this.vrInfo.erHolidayDistrict = this.vrInfo.erAddHolidayDistrict[2];

          this.submitLoading = true;
          
          this.companyList.forEach(item => {
            if (item.companyId == this.vrInfo.baseCompanyId) {
              this.vrInfo.baseCompanyName = item.companyName;
            }
          });

          getData
            .addEpidemicRegister(this.vrInfo)
            .then(res => {
              this.submitLoading = false;
              if (res.data.code != 1) {
                this.$message({
                  type: "error",
                  message: res.data.message || res.data.msg
                });
                return;
              }
              if(this.id){
                this.$message.success("编辑成功！");
              }else{
                this.$message.success("上传成功！");
              }
              this.close(1);
            })
            .catch(_ => {
              console.log(_);
              this.submitLoading = false;
            });
        }
      });
    },
    changeTraffic(attr) {
      if (this.vrInfo[attr] == 1) {
        this.vrInfo[attr] = 2;
      } else {
        this.vrInfo[attr] = 1;
      }
    }
  },
  components: {},
  watch: {}
};
</script>
<style scoped lang="scss">
@import "../../assets/css/mixin";
</style>
<style lang="scss">
.g-assign-item {
  .el-form-item__label {
    padding: 0;
  }
}
.title-label-right {
  float: right;
  color: #169bd5;
}
.g-basic-info {
  .info-item {
    border: 1px dashed #eee;
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 10px;
    &::after {
      content: "";
      zoom: 1;
      display: block;
      clear: both;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  p {
    span {
      color: #666;
      &.red {
        color: #ff0000;
      }
      &.green {
        color: #00ae0d;
      }
    }
  }
}
.font-blod {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/防疫/prevent-plague-add.vue